import React, { Component } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import { ALERT_SEVERITY } from './AlertDisplay2';

export const DAYS = {
    0: 'MONDAY',
    1: 'TUESDAY',
    2: 'WEDNESDAY',
    3: 'THURSDAY',
    4: 'FRIDAY',
    5: 'SATURDAY',
    6: 'SUNDAY',
};

const DAY_SHORTCUTS = {
    MONDAY: 'Mo',
    TUESDAY: 'Di',
    WEDNESDAY: 'Mi',
    THURSDAY: 'Do',
    FRIDAY: 'Fr',
    SATURDAY: 'Sa',
    SUNDAY: 'So',
};

const createTimeDate = (hours, minutes) => {
    const d = new Date();
    d.setHours(hours, minutes, 0, 0);
    return d;
};

const formatTime = (date) => {
    return date.toLocaleTimeString('de-DE', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
};

const formatInputTime = (date) => {
    const h = `${date.getHours()}`.padStart(2, '0');
    const m = `${date.getMinutes()}`.padStart(2, '0');
    return `${h}:${m}`;
};

const parseTimeStringToDate = (timeStr) => {
    const [hours, minutes] = String(timeStr).split(':').map(Number);
    return createTimeDate(hours, minutes);
};

class DayTimeRangeInput extends Component {
    constructor(props) {
        super(props);

        const beginTime = createTimeDate(8, 0);
        const endTime = createTimeDate(19, 0);

        this.state = {
            startHour: '08:00',
            endHour: '19:00',
            pickerOpen: false,
            pickerValue: '08:00',
            editingStartTime: true,
            startHourDate: beginTime,
            endHourDate: endTime,
            minTime: '',
            maxTime: '',
        };
    }

    openStartPicker = () => {
        const { endHourDate } = this.state;

        const maxDate = new Date(endHourDate.getTime() - 60000);

        this.setState({
            pickerOpen: true,
            pickerValue: formatInputTime(this.state.startHourDate),
            editingStartTime: true,
            minTime: '',
            maxTime: formatInputTime(maxDate),
        });
    };

    openEndPicker = () => {
        const { startHourDate } = this.state;

        const minDate = new Date(startHourDate.getTime() + 60000);

        this.setState({
            pickerOpen: true,
            pickerValue: formatInputTime(this.state.endHourDate),
            editingStartTime: false,
            minTime: formatInputTime(minDate),
            maxTime: '',
        });
    };

    confirmTime = () => {
        const { showAlert } = this.props;
        const nextDate = parseTimeStringToDate(this.state.pickerValue);

        let err = false;

        if (this.state.editingStartTime) {
            if (nextDate < this.state.endHourDate) {
                this.setState({
                    startHourDate: nextDate,
                    startHour: formatTime(nextDate),
                    pickerOpen: false,
                });
            } else {
                err = true;
                showAlert?.('Die Startzeit muss vor der Endzeit liegen.', ALERT_SEVERITY.ERROR);
            }
        } else {
            if (nextDate > this.state.startHourDate) {
                this.setState({
                    endHourDate: nextDate,
                    endHour: formatTime(nextDate),
                    pickerOpen: false,
                });
            } else {
                err = true;
                showAlert?.('Die Endzeit muss nach der Startzeit liegen.', ALERT_SEVERITY.ERROR);
            }
        }

        if (err) {
            this.setState({ pickerOpen: false });
        }
    };

    getDayLabel = (index) => {
        if (index === -1 || index == null) {
            return 'Wochentag';
        }

        return DAY_SHORTCUTS[DAYS[index]];
    };

    render() {
        const { dayPickerSelection = [-1, -1], singleMode, openDayPickerDialog, addOpeningHour } = this.props;
        const height = singleMode ? 50 : 100;
        return (
            <>
                <Box
                    sx={{
                        borderRadius: '5px',
                        display: 'flex',
                        alignItems: 'stretch',
                        border: '0.5px solid #EAEAEA',
                        minHeight: height,
                        overflow: 'hidden',
                    }}
                >
                    <Box sx={{ height: '100%', flex: 1 }}>
                        <Box
                            onClick={() => openDayPickerDialog?.(0)}
                            sx={{
                                backgroundColor: '#F3F3F3',
                                flex: 1,
                                minHeight: height,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer',
                            }}
                        >
                            <Typography sx={{ fontSize: 14, width: '90%', textAlign: 'center', color: '#353535' }}>
                                {this.getDayLabel(dayPickerSelection[0])}
                            </Typography>
                        </Box>

                        {!singleMode && (
                            <Box
                                onClick={() => openDayPickerDialog?.(1)}
                                sx={{
                                    borderTop: '0.5px solid #CACACA',
                                    backgroundColor: '#F3F3F3',
                                    flex: 1,
                                    minHeight: height,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                }}
                            >
                                <Typography sx={{ fontSize: 14, width: '90%', textAlign: 'center', color: '#353535' }}>
                                    {this.getDayLabel(dayPickerSelection[1])}
                                </Typography>
                            </Box>
                        )}
                    </Box>

                    <Box
                        onClick={this.openStartPicker}
                        sx={{
                            height: height,
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRight: '0.5px solid #EAEAEA',
                            borderLeft: '0.5px solid #EAEAEA',
                            cursor: 'pointer',
                        }}
                    >
                        <Typography sx={{ fontSize: 14, width: '90%', textAlign: 'center', color: '#353535' }}>
                            {this.state.startHour}
                        </Typography>
                    </Box>

                    <Box
                        onClick={this.openEndPicker}
                        sx={{
                            height: height,
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRight: '0.5px solid #EAEAEA',
                            borderLeft: '0.5px solid #EAEAEA',
                            cursor: 'pointer',
                        }}
                    >
                        <Typography sx={{ fontSize: 14, width: '90%', textAlign: 'center', color: '#353535' }}>
                            {this.state.endHour}
                        </Typography>
                    </Box>

                    <Box
                        onClick={() => addOpeningHour?.(this.state.startHourDate, this.state.endHourDate)}
                        sx={{
                            height: height,
                            flex: 1,
                            backgroundColor: '#FF952F',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                        }}
                    >
                        <Typography sx={{ color: 'white', fontWeight: 'bold', fontSize: 14 }}>
                            Hinzufügen
                        </Typography>
                    </Box>
                </Box>

                <Dialog
                    open={this.state.pickerOpen}
                    onClose={() => this.setState({ pickerOpen: false })}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle>Zeit wählen</DialogTitle>

                    <DialogContent>
                        <Box sx={{ pt: 1 }}>
                            <input
                                type="time"
                                value={this.state.pickerValue}
                                min={this.state.minTime || undefined}
                                max={this.state.maxTime || undefined}
                                onChange={(e) => this.setState({ pickerValue: e.target.value })}
                                style={{
                                    width: '100%',
                                    height: height,
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    padding: '0 12px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box',
                                }}
                            />
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => this.setState({ pickerOpen: false })}>Abbrechen</Button>
                        <Button variant="contained" onClick={this.confirmTime}>Bestätigen</Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default DayTimeRangeInput;